export const DEFAULT_LOGO_CONFIG = {
  width: 193,
  height: 40,
  margin_top: 83,
  margin_bottom: 84,
};

export const DEFAULT_EMOJI_ICON_SIZE = 58;
